import BackendService from './BackendService';

export default class FormPackService {
  static getFormPacks(dealerId) {
    const params = { dealerId };
    return BackendService.get('/formPacks/all', { params });
  }

  static getFormPack(formPackId) {
    return BackendService.get(`/formPacks/${formPackId}`);
  }

  static createFormPack(form) {
    return BackendService.post('/formPacks', { body: form });
  }

  static updateFormPack(formPack) {
    return BackendService.put(`/formPacks/${formPack.id}`, {
      body: formPack,
    });
  }

  static deleteFormPack(formPackId) {
    return BackendService.delete(`/formPacks/${formPackId}`);
  }
}
